<template>
  <div>
    <el-form ref="form" :rules="rules" :model="form" label-width="100px">
      <el-form-item label="友链名:" prop="name">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="友链头像:" prop="photo">
        <el-input v-model="form.photo"></el-input>
      </el-form-item>
      <el-form-item label="友链描述:" prop="description">
        <el-input v-model="form.description"></el-input>
      </el-form-item>
      <el-form-item label="友链网站:" prop="url">
        <el-input v-model="form.url"></el-input>
      </el-form-item>
      <el-form-item label="友链邮箱:" prop="email">
        <el-input v-model="form.email"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" @click="onSubmit('form')">{{
          editID == 0 ? "添加" : "修改"
        }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    editID: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      imageUrl: "",
      form: {
        photo: '',
        name: '',
        description: '',
        time: '',
        switch: 0
      },
      rules: {
        photo: [{ required: true, message: "友链头像地址不能为空", trigger: "blur" }],
        name: [{ required: true, message: "友链名称不能为空", trigger: "blur" }],
        url: [{ required: true, message: "友链地址不能为空", trigger: "blur" }],
        email: [{ required: true, message: "友链邮箱不能为空", trigger: "blur" }],
        description: [{ required: true, message: "友链描述不能为空", trigger: "blur" }],
      },
    };
  },
  methods: {
    onSubmit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          this.$message.error("添加失败");
          return false;
        }
        if (this.editID > 0) {
          const { data: res } = await this.$axios.post(
            "/links/editLinks",
            this.form
          );
          console.log(res);
          if (res.meta.status !== 200) return this.$message.error(res.meta.msg);
          this.$emit("onDialog", false);
          return this.$message.success(res.meta.msg);
        } else {
          const { data: res } = await this.$axios.post(
            "links/addLinks",
            this.form
          );
          console.log(res);
          if (res.meta.status !== 200) return this.$message.error(res.meta.msg);
          this.$emit("onDialog", false);
          return this.$message.success(res.meta.msg);
        }
      });
    },
    async getProject(id) {
      const { data: res } = await this.$axios.post("/links/getLinksId", {
        id: id,
      });
      console.log(res);
      this.form = res.data;
    },
  },
  created() {
    if (this.editID > 0) {
      console.log(this.editID);
      this.getProject(this.editID);
    }
  },
}
</script>

<style lang="less">
.el-input,
.el-textarea {
  max-width: 800px;
}
</style>


// WEBPACK FOOTER //
// src/components/links/addLinks.vue